import type { PropsWithChildren } from "react";
import { SlideLessonPageContext } from "#slide-lesson-page-context";
import { useSlideLessonPageContextValue } from "#slide-lesson-page-context-value";

export function SlideLessonPageContextProvider({
  children,
  ...props
}: PropsWithChildren<Parameters<typeof useSlideLessonPageContextValue>[0]>) {
  const value = useSlideLessonPageContextValue(props);
  return (
    <SlideLessonPageContext.Provider value={value}>{children}</SlideLessonPageContext.Provider>
  );
}
